import { TruncatedText } from "@/components/common/truncated-text";
import { Image } from "@/components/common/image";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn } from "@/utils/cn";

interface AccountProps {
  /** 用户姓名 */
  name: string;
  /** 用户邮箱 */
  email?: string;
  /** 头像图片URL */
  avatar?: string;
  /** 是否为缩略版，true时只显示头像 */
  compact?: boolean;
  /** 头像大小 */
  size?: "sm" | "md" | "lg" | "xl" | "xxl";
  /** 自定义类名 */
  className?: string;
}

const getInitials = (name: string) => {
  return name
    ?.split(" ")
    .map((word) => word.charAt(0))
    .join("")
    .toUpperCase()
    .slice(0, 2);
};

const sizeClasses = {
  sm: "h-6 w-6",
  md: "h-8 w-8",
  lg: "h-10 w-10",
  xl: "h-12 w-12",
  xxl: "h-16 w-16",
};

export function AccountCard({
  name,
  email,
  avatar,
  compact = false,
  size = "md",
  className,
}: AccountProps) {
  if (compact) {
    return (
      <Avatar className={cn("size-7", className)}>
        {avatar ? (
          <Image src={avatar} alt={name} className="w-full h-full object-cover rounded-full" /> 
        ) : (
          <AvatarFallback className="bg-teal-600 text-white text-sm">
            {getInitials(name)}
          </AvatarFallback>
        )}
      </Avatar>
    );
  }

  return (
    <div className={cn("flex items-center gap-3", className)}>
      <Avatar className={"size-7"}>
        {avatar ? (
          <Image src={avatar} alt={name} />
        ) : (
          <AvatarFallback className="bg-teal-600 text-white">
            {getInitials(name)}
          </AvatarFallback>
        )}
      </Avatar>
      <div className="flex flex-col w-[80%]">
        <TruncatedText text={name} className="flex-1 text-sm text-i-normal" />
        <TruncatedText
          text={email}
          className="text-xs text-[rgba(71,84,103,1)]"
        />
      </div>
    </div>
  );
}
